// Resolves a resource's localized display name from the catalog structure's
// `names` map (ResourceStructureResponse.names, carried through by
// roleTransformer). A resource declared in the product's config always has
// `en`, so that's the fallback before finally showing the raw id — the only
// option left for a resource the config doesn't declare at all (empty map).
import type { ResourceDef } from '../types'

export function resourceDisplayName(resource: ResourceDef, language: string): string {
  return resource.names[language] ?? resource.names.en ?? resource.id
}
